import type { RuleEntry, RuleTypeMutation } from '../../types';

export const getFacebookInitialValues = (rule: RuleEntry, mode: RuleTypeMutation) => ({
  name: rule.name,
  project: rule.project_id,
  ruleStatus: rule.status,
  level: rule.level,
  description: rule.description,
  groupId: `${rule.group.id}`,
  facebookAdAccountIds: rule.data.facebook_ad_account_ids.map(String),
  notificationChannels: rule.data.notification_channels.map((n) => n.id),
  notificationLevel: rule.data.notification_level,
  notificationMessage: {
    title: rule.data.notification_message?.title ?? null,
    body: rule.data.notification_message?.body ?? null,
  },
  networkId: rule.network_id,
  actionTypesIds: rule.action_types.map((at) => at.id),
  mode,
});

export default getFacebookInitialValues;
